import React, { useState, useEffect } from 'react'
import { formatDecimal, numberFormat, numberFormatDestroy } from '../../utility/Helpers'
import { currency } from '../../constant/global/currency'

const InputCurrency = (data) => {
  const maximum = 50000000000
  const allowDecimal = typeof data.decimal === 'number' && data.decimal > 0

  const [value, setValue] = useState(() => formatDecimal(data.value, data.decimal ?? 0))

  useEffect(() => {
    const formatted = formatDecimal(data.value, data.decimal ?? 0)
    setValue(formatted)
  }, [data.value, data.decimal])

  const onChange = (e) => {
    e.preventDefault()
    const rawValue = e.target.value
    const commaCount = (rawValue.match(/,/g) || []).length

    // Cegah input lebih dari satu koma
    if (!allowDecimal && commaCount > 0) return
    if (allowDecimal && commaCount > 1) return

    // Cek batas jumlah angka desimal
    if (allowDecimal && rawValue.includes(',')) {
      const [, decimalPart = ''] = rawValue.split(',')
      if (decimalPart.length > data.decimal) return
    }

    // Langsung tampilkan input yang diketik user
    setValue(rawValue)

    const inputValue = numberFormatDestroy(rawValue)
    const numericValue = Number(inputValue)

    // Kirim ke parent jika valid number dan input tidak kosong
    if (!isNaN(numericValue) && inputValue !== '') {
      let val = numericValue

      // Batas minimum & maksimum
      if (val > maximum) val = maximum
      if (!data.zeroMinValue) {
        if (val < 1) val = 1
      }

      // Format untuk value yang akan dikirim
      const valueForParent = allowDecimal
        ? formatDecimal(val, data.decimal) // -> "5,00"
        : val

      data.onChange({
        id: data.id,
        value: valueForParent,
      })

      // Format tampilan hanya kalau user tidak sedang ngetik koma atau nol setelah koma
      const isTypingDecimal = rawValue.endsWith(',') || rawValue.match(/,\d*0*$/)
      if (!isTypingDecimal) {
        setValue(valueForParent)
      }
    }
  }

  const onChangeBlur = (e) => {
    e.preventDefault()

    const inputValue = numberFormatDestroy(e.target.value)

    if (inputValue === '' || inputValue === '0') {
      const defaultValue = data.zeroMinValue ? 0.00001 : 1

      data.onChange({
        id: data.id,
        value: defaultValue,
      })

      setValue(numberFormat(defaultValue, { leadingZeroAllowed: data.zeroMinValue }))
    } else {
      setValue(numberFormat(inputValue, { leadingZeroAllowed: data.zeroMinValue }))
    }

    // trigger parent blur
    if (typeof data.onBlur === 'function') {
      data.onBlur({
        id: data.id,
        value: inputValue,
      })
    }
  }

  return (
    <div className={`input-group ${data.wrapperClassName || ''}`} style={data.wrapperStyle}>
      <div className="input-group-append">
        <span
          className="btn border-radius-left p-1 pl-3 pr-2 btn-xs btn-gray-4 text-secondary font-weight-bold font-size-14"
          style={data.currencyStyle}
        >
          {currency[data.currency]}
        </span>
      </div>

      <input
        type="text"
        value={value}
        onChange={onChange}
        onBlur={onChangeBlur}
        className={`pl-2 py-3 height-20 form-control ${data.inputClassName || ''}`}
        style={data.inputStyle}
        readOnly={data.readOnly}
      />
    </div>
  )
}

export default InputCurrency
